import React from 'react';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
import urlBase from '../../url-base';

import '../../assets/css/icon_report.css';

class Compliance extends React.Component {


    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>GOVERNANÇA E COMPLIANCE</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>

                </Container>

                <Container style={{ marginTop: -40 }}>
                    <Row style={{ marginRight: -40 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="10" xl="3">
                            <Sidebar />
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="10" lg="10" xl="8">
                           <p className="text_footer">COMPLIANCE</p>
                            <div className="line_footer_gradient">{""}</div>
                            <br/>
                            <p style={{ textAlign: 'justify' }}>
                            A palavra compliance significa “agir de acordo” com uma ordem, norma, legislação, regulamentos e políticas internas.
                           </p>
                           <br/>
                           <p style={{ textAlign: 'justify' }}>
                           A Dental Center, por meio da sua política de compliance, reafirma o seu compromisso com a condução dos seus negócios, pautando-se em padrões, ética, integridade, transparência e profissionalismo, reafirmando sempre que preza pelo cumprimento da legislação que se aplica ao seu negócio, embasando-se sempre nas melhores práticas de mercado em relação aos seus clientes, parceiros, credenciados e demais atores que mantêm relação com a Dental Center.
                           </p>   
   
                                <Row style={{ paddingLeft: 0, marginTop: '-46px' }}>
                                        <Col style={{ paddingLeft: 0, marginTop: 60,  paddingTop: 33, paddingRight: 0 }} xs="12" sm="12" md="12" lg="12" xl="3">
                                            <div className='icon_politica_controle_interno'></div>
                                            <div className='title_report' style={{ cursor: 'pointer', textAlign : 'center' }} ><a href={urlBase.client+'assets/pdf/politica-controle-interno.pdf'}>Política de Controles Internos</a></div>
                                        </Col>
                                        <Col style={{ paddingLeft: 0, marginTop: 60, paddingTop: 33, paddingRight: 0 }} xs="12" sm="12" md="12" lg="12" xl="2">
                                                <div className='icon_politica_governanca'></div>
                                                <div className='title_report' style={{ cursor: 'pointer', textAlign : 'center' }} ><a href={urlBase.client+'assets/pdf/politica-governanca-corporativa.pdf'}>Política de Governança Corporativa</a></div>
                                        </Col>
                                        <Col style={{ paddingLeft: 0, marginTop: 60,  paddingTop: 33, paddingRight: 0 }} xs="12" sm="12" md="12" lg="10" xl="2">
                                                 <div className='icon_politica_compliance'></div>
                                                <div className='title_report' style={{ cursor: 'pointer', textAlign : 'center' }} ><a href={urlBase.client+'assets/pdf/politica-compliance.pdf'}>Política de Compliance</a></div>
                                        </Col>   
                                        <Col style={{paddingLeft: 0,  marginTop: 60,  paddingTop: 33, paddingRight: 0 }} xs="12" sm="12" md="12" lg="10" xl="2">
                                                <div className='icon_politica_gestao_risco'></div>
                                                <div className='title_report' style={{ cursor: 'pointer', textAlign : 'center' }} ><a href={urlBase.client+'assets/pdf/politica_riscos.pdf'}>Política de Riscos</a></div>
                                        </Col> 
                                        <Col style={{ paddingLeft: 0, marginTop: 60,  paddingTop: 33, paddingRight: 0 }} xs="12" sm="12" md="12" lg="10" xl="3">
                                                <div className='icon_programa_integridade'></div>
                                                <div className='title_report' style={{ cursor: 'pointer', textAlign : 'center' }} ><a href=''>Programa de Integridade</a></div>
                                        </Col>                                                 
                                            
                                </Row>                                                                                                                                                           
                        </Col>

                    </Row>
                                                  
                </Container>
                <Footer />
            </div>

        );
    }
}
export default Compliance;



/** WEBPACK FOOTER **
 ** ./src/components/Governanca/Compliance.js
 **/